import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-informativo-jucesp',
  templateUrl: './modal-informativo-jucesp.component.html',
  styleUrls: ['./modal-informativo-jucesp.component.scss']
})
export class ModalInformativoJucespComponent implements OnInit {

  @Input() dados: any;  
  codbase64: any;
  contentType: any;
  isText: boolean = false;
  isMsgPadrao: boolean = false;
  classTitulo: any;
  tipocomunicado: any;  

  constructor(
    public activeModal: NgbActiveModal,
    public sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {

    const tipoComunicado = this.dados.tipoComunicado;

    switch (tipoComunicado) {
      case 'ERRO':
        this.classTitulo = 'modal-title text-danger'
        break;
      case 'PROBLEMA':
        this.classTitulo = 'modal-title text-danger'
        break;
      case 'ALERTA':
        this.classTitulo = 'modal-title text-warning'
        break;
      case 'INFORMACAO':
        this.classTitulo = 'modal-title text-info'
        break;
      default:
        this.classTitulo = 'modal-title'
    }

    // if(this.dados.contentType == null || this.dados.contentType == ''){
    //   this.isMsgPadrao = true;
    // }

    if (this.dados.imagemDownload) {
      this.codbase64 = `data:${this.dados.contentType};base64,${this.dados.imagemDownload}`;
    }

  }

}
